import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
import * as firebase from "firebase/app";
import "firebase/auth";
import { Router } from "@angular/router";
import { first } from "rxjs/operators";
import { CommonApiService } from "src/app/services/common-api.service";
import { NgForm } from "@angular/forms";
import * as $ from "jquery"
import * as _ from "lodash";
import intlTelInput from 'intl-tel-input';
// @import 'intl-tel-input/build/css/intlTelInput.css';


declare var $: any;
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  phoneNumber: any;
  phoneNumberString: any;
  countryCode: any;
  public recaptchaVerifier: firebase.auth.RecaptchaVerifier;
  user: firebase.User;
  userSubscription: any;

  verify_section: boolean = true;
  otp_section: boolean = false;
  confirmationResultOtp: any;
  code1: any;
  code2: any;
  code3: any;
  code4: any;
  code5: any;
  code6: any;

  meter_id: any;
  form_verify: NgForm;
  opt_form: NgForm;
  otp: any;
  loader: boolean = false;
  otpTimer: any;
  cc: any = []
  iti:any;

  @ViewChild("myDiv") divView: ElementRef;


  constructor(
    public afAuth: AngularFireAuth,
    public _router: Router,
    public commonApi: CommonApiService,
    private httpClient: HttpClient
  ) { }



  showUnregisteredMessage(): void {

    this.divView.nativeElement.style.display = 'block';
    console.log(this.divView.nativeElement);

    // let modalEl = $("#modal_unregistered");
    // if (modalEl) {
    //   modalEl.modal("show");
    // }
  }

  hideUnregisteredMessage(): void {
    // let modalEl = $("#modal_unregistered");
    // if (modalEl) {
    //   modalEl.modal("hide");
    // }
  }

  ngAfterViewInit() {
    const input = document.querySelector("#phoneNumber");
    this.iti = intlTelInput(input, {
        // any initialisation options go here
        initialCountry : "IN"
    });
  }

  ngOnInit(): void {

    this.httpClient.get("assets/json/country.json").subscribe(data => {
      this.cc = data;
    })

    if (localStorage.getItem("user")) {
      this._router.navigate(["/dashboard"]);
    } else {
      this.hideUnregisteredMessage()
      this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: function (response) {
            // reCAPTCHA solved - will proceed with submit function
            console.log(response);
          },
          "expired-callback": function () {
            // Reset reCAPTCHA?
          },
        }
      );
      this.recaptchaVerifier.render();

      console.log("Componenet mounted");
      this.userSubscription = this.afAuth.authState.subscribe((user) => {
        console.log(user);

        if (user) {
          localStorage.setItem("firebaseUser", JSON.stringify(user));
          this.user = user;
          this.userSubscription.unsubscribe();
        }
      });
    }
    // localStorage.clear();
    // localStorage.removeItem("authToken");
    // localStorage.removeItem("firebaseUser");
    // this.afAuth.signOut();
  }

  async getOtp() {
 
    const appVerifier = this.recaptchaVerifier;
    this.phoneNumberString = "+" + this.iti.selectedCountryData.dialCode + this.phoneNumber;
    console.log(this.phoneNumberString);
    

    try {
      let result = await this.afAuth.signInWithPhoneNumber(
        this.phoneNumberString,
        appVerifier
      );
      //   .then(function (confirmationResult) {
      //     console.log(confirmationResult)
      //     this.confirmationResultOtp = confirmationResult;
      //     console.log(this.confirmationResultOtp);

      // }).catch(function (error) {
      //   console.log(error);

      // });
      console.log(result);
      this.confirmationResultOtp = result;

      $("#otp_section").removeClass("hidden").addClass("visible");
      $("#verify_section").removeClass("visible").addClass("hidden");
      this.resendText();

      // this.getNavigateTools();
      // this.toastr.success("Login successfull")
    } catch (error) {
      console.log(error);
    }
  }

  // OTP
  getCodeBoxElement(index) {
    return document.getElementById("codeBox" + index);
  }
  onKeyUpEvent(index, event) {
    console.log(index, event);

    const eventCode = event.which || event.keyCode;
    if (this.getCodeBoxElement(index)["value"].length === 1) {
      // if (this.getCodeBoxElement(index).value.length === 1) {
      if (index !== 6) {
        this.getCodeBoxElement(index + 1).focus();
      } else {
        this.getCodeBoxElement(index).blur();
        // Submit code
        console.log("submit code ");
        // this.verify_otp();
        // let formData: FormData = new FormData();
        this.otp =
          this.code1 +
          "" +
          this.code2 +
          "" +
          this.code3 +
          "" +
          this.code4 +
          "" +
          this.code5 +
          "" +
          this.code6 +
          "";
        // formData.append("code", otp);
        console.log("OTP is ==>", this.otp);

        this.loader = true;



        this.confirmationResultOtp
          .confirm(this.otp)
          .then((result) => {
            this.loader = false;
            console.log(result);
            // User signed in successfully.
            var user = result.user;
            console.log(user);
            user.getIdToken(false).then(console.log);
            this.updateUser();
          })
          .catch((error) => {
            console.log(error);
            // User couldn't sign in (bad verification code?)
            // ...
          });
      }
    }
    if (eventCode === 8 && index !== 1) {
      this.getCodeBoxElement(index - 1).focus();
    }
  }
  onFocusEvent(index) {
    console.log(index);
    for (let item = 1; item < index; item++) {
      const currentElement = this.getCodeBoxElement(item);
      if (!currentElement["value"]) {
        currentElement.focus();
        break;
      }
    }
  }

  editNumber() {
    $("#otp_section").removeClass("visible").addClass("hidden");
    $("#verify_section").removeClass("hidden").addClass("visible");
    this.phoneNumber = "";
    this.code1 = "";
    this.code2 = "";
    this.code3 = "";
    this.code4 = "";
    this.code5 = "";
    this.code6 = "";
  }

  verify_otp() {
    this.hideUnregisteredMessage();
    console.log(this.confirmationResultOtp);
    this.updateUser();
  }

  updateUser() {
    this.commonApi
      .userUpdate({})
      .pipe(first())
      .subscribe((res) => {
        this.hideUnregisteredMessage();
        console.log(res, "UPDATE USER AFTER LOGIN");
        if (res) {
          this.hideUnregisteredMessage();
          localStorage.setItem("user", JSON.stringify(res));
          if (res["meters"].length === 0) {
            console.log("unresgiertes");
            // $("#modal_unregistered").removeClass("hidden").addClass("visble");
            this._router.navigate(['/unregister'])
            localStorage.clear();
            // this.showUnregisteredMessage();
          } else {
            // this.hideUnregisteredMessage();
            this.meter_id = res["meters"];
            this.commonApi.setSelectedMeterId(res["meters"][0]);
            this.commonApi.meter_id = this.meter_id;
            if (res["displayName"] === null) {
              this._router.navigate(["/profile"]);
            } else {
              this._router.navigate(["/dashboard"]);
            }
          }
        }
      });
  }

  closeModal() {
    $("#otp_section").removeClass("visible").addClass("hidden");
    $("#verify_section").removeClass("hidden").addClass("visible");
    this.phoneNumber = "";
    this.code1 = "";
    this.code2 = "";
    this.code3 = "";
    this.code4 = "";
    this.code5 = "";
    this.code6 = "";
    this._router.navigate(["/login"]);
    localStorage.clear();
    localStorage.removeItem("user");
  }



  resendText() {
    let timeleft = 60;
    this.otpTimer = setInterval(function () {
      if (timeleft <= 0) {
        clearInterval(this.otpTimer);
        document.getElementById("countdownOpt").innerHTML = "Resent OTP";
        document.getElementById("countdown").innerHTML = "";
      } else {

        document.getElementById("countdown").innerHTML = timeleft + " seconds remaining";
        document.getElementById("countdownOpt").innerHTML = "";
      }
      timeleft -= 1;
    }, 1000);
  }

  resendOTP() {
    console.log("resend");
    this.getOtp();

  }

  ngOnDestroy() {
    document.getElementById("countdown").innerHTML = "";
    document.getElementById("countdownOpt").innerHTML = "";
    clearInterval(this.otpTimer);
  }
}
